export default function Loading() {
  return (
    <ul>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <style jsx>{`
        li {
          height: var(--space-sm);
          margin-bottom: var(--space-xs);
          width: var(--space-lg);
          background-color: var(--color-gray-90);
        }
      `}</style>
    </ul>
  );
}
